var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram",
    clipPath: "url(#clip0_35_61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6667 4.33331H11.6733M4.66667 1.33331H11.3333C13.1743 1.33331 14.6667 2.8257 14.6667 4.66665V11.3333C14.6667 13.1743 13.1743 14.6666 11.3333 14.6666H4.66667C2.82572 14.6666 1.33334 13.1743 1.33334 11.3333V4.66665C1.33334 2.8257 2.82572 1.33331 4.66667 1.33331ZM10.6667 7.57998C10.7489 8.13481 10.6542 8.70146 10.3958 9.19932C10.1375 9.69719 9.72877 10.1009 9.22775 10.3531C8.72674 10.6053 8.15897 10.693 7.60519 10.6039C7.05142 10.5148 6.53984 10.2534 6.14323 9.85675C5.74661 9.46014 5.48516 8.94856 5.39605 8.39479C5.30694 7.84102 5.39471 7.27324 5.64689 6.77223C5.89906 6.27122 6.30279 5.86247 6.80066 5.60414C7.29852 5.34581 7.86517 5.25104 8.42 5.33331C8.98595 5.41724 9.5099 5.68096 9.91446 6.08552C10.319 6.49008 10.5827 7.01403 10.6667 7.57998Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.208dbb9a15b40e626e6e8f62ba98199e.svg";
export { ForwardRef as ReactComponent };